import { EntitySetName, EntityTypeName } from "@odata/GeneratedEntityTypes";
import { getEnumNameSpaceName } from "@odata/GeneratedEnums.utils";
import { getDefFormAccount } from "@pages/banks/bankAccounts/BankAccountsDef";
import i18next from "i18next";

import { LOAN_ACCOUNT_BALANCE_SHEET_ACCOUNT_PREFIX } from "../../../constants";
import { IAppContext } from "../../../contexts/appContext/AppContext.types";
import { AccountType } from "../../banks/bankAccounts/BankAccounts.utils";
import { setDefByEntityType } from "../../getDefByEntityType";
import { IDefinition, IGetDefinition } from "../../PageUtils";


export const getDefinitions: IGetDefinition = (context: IAppContext): IDefinition => {
    const form = getDefFormAccount(context, LOAN_ACCOUNT_BALANCE_SHEET_ACCOUNT_PREFIX, AccountType.Loan);

    form.id = `${EntityTypeName.LoanAccount}Form`;
    form.fieldDefinition.CompanyBankAccountType.label = i18next.t("Banks:LoanAccounts.AccountType");
    form.fieldDefinition.CompanyBankAccountType.fieldSettings.items[0].label = i18next.t("Banks:LoanAccounts.LoanType");

    form.fieldDefinition.Name.label = i18next.t("Banks:LoanAccounts.AccountName");

    return {
        form,
        entitySet: EntitySetName.LoanAccounts
    };
};

getDefinitions.translationFiles = [
    "Banks",
    getEnumNameSpaceName(EntityTypeName.Currency),
    getEnumNameSpaceName(EntityTypeName.BankApiStatementImportFrequency),
    getEnumNameSpaceName(EntityTypeName.BankApiStatementImportRange)
];

setDefByEntityType(EntityTypeName.LoanAccount, getDefinitions);